import React from 'react';
import { Icon } from '../core/Icon.jsx';

/** Circular play/pause button — the platform's signature control. */
export function PlayButton({ playing = false, size = 'md', label, className = '', style, ...rest }) {
  const numeric = typeof size === 'number';
  return (
    <button
      className={`bjl-playbtn ${numeric ? '' : `bjl-playbtn--${size}`} ${className}`}
      style={numeric ? { width: size, height: size, ...style } : style}
      aria-label={label || (playing ? '暂停' : '播放')}
      title={label || (playing ? '暂停' : '播放')}
      {...rest}
    >
      <Icon name={playing ? 'pause' : 'play_arrow'} fill style={{ verticalAlign: 0 }} />
    </button>
  );
}
